export default function () {
  const moduleName = 'auth'
  Array.from(document.querySelectorAll('.js-auth')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init']) return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const btnToggle = wrapper.querySelector('.js-auth-btn-toggle')
    const btnClose = wrapper.querySelector('.js-auth-btn-close')

    btnToggle.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      wrapper.classList.toggle('active')
    })

    btnClose.addEventListener('click', (event) => {
      event.preventDefault()

      wrapper.classList.remove('active')
    })

    document.addEventListener('click', (event) => {
      if (!(event.target.closest('.js-auth-container'))) {
        wrapper.classList.remove('active')
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) {
        event.preventDefault()

        wrapper.classList.remove('active')
      }
    })
  })
};
